export const isAuthenticated = () => {
  return !!store.get('token')
}
